import { render } from "./IntakePage.vue?vue&type=template&id=0b86edf1&scoped=true"
import script from "./IntakePage.vue?vue&type=script&lang=js"
export * from "./IntakePage.vue?vue&type=script&lang=js"

import "./IntakePage.vue?vue&type=style&index=0&id=0b86edf1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b86edf1"]])

export default __exports__